import React from 'react';
import { Search, Settings } from 'lucide-react';
import type { SearchRequest, JobDescription } from '../shared/types';

interface SimpleSearchProps {
  onSearch: (request: SearchRequest) => void;
  onAdvancedToggle: () => void;
  isLoading: boolean;
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
}

export function SimpleSearch({ onSearch, onAdvancedToggle, isLoading, searchQuery, onSearchQueryChange }: SimpleSearchProps) {

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!searchQuery.trim()) return;

    // Create a basic job description from the search query
    const jobDescription: JobDescription = {
      title: 'Software Engineer', // Default title
      company: 'Tech Company', // Default company
      description: searchQuery,
      requirements: [searchQuery], // Use search query as requirement
      experienceLevel: 'mid',
      remoteOk: true,
    };

    const searchRequest: SearchRequest = {
      jobDescription,
      limit: 20,
    };

    console.log('Simple search request:', searchRequest);
    onSearch(searchRequest);
  };

  return (
    <div className="bg-gray-900 text-white">
      {/* Header */}
      <div className="sticky top-0 z-50 bg-gray-900/95 backdrop-blur-sm border-b border-gray-800">
        <div className="max-w-4xl mx-auto px-6 py-8">
          {/* Logo */}
          <div className="text-center mb-8">
            <h1 className="text-4xl font-light tracking-wide text-white mb-2">
              student<span className="text-blue-400">search</span>
            </h1>

          </div>

          {/* Search Bar */}
          <form onSubmit={handleSubmit} className="relative max-w-2xl mx-auto">
            <div className="relative">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => onSearchQueryChange(e.target.value)}
                placeholder="Describe your ideal student or paste a job description..."
                className="w-full bg-gray-800 border border-gray-700 rounded-xl pl-12 pr-32 py-4 text-white placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors"
              />
              <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center space-x-2">
                <button
                  type="button"
                  onClick={onAdvancedToggle}
                  className="flex items-center space-x-1 px-3 py-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors text-sm"
                >
                  <Settings className="w-4 h-4" />
                  <span>Advanced</span>
                </button>
                <button
                  type="submit"
                  disabled={isLoading || !searchQuery.trim()}
                  className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-700 disabled:cursor-not-allowed text-white px-4 py-2 rounded-lg transition-colors flex items-center space-x-2"
                >
                  {isLoading ? (
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  ) : (
                    <Search className="w-4 h-4" />
                  )}
                  <span>{isLoading ? 'Searching...' : 'Search'}</span>
                </button>
              </div>
            </div>
          </form>


        </div>
      </div>


    </div>
  );
}
